export const SELLY_EXCLUDE_DISCOUNTS_TAG = 'ExcludeAnyDiscounts';
export const SELLY_CART_ATTRIBUTE_PREFIX = '_slpromos';
